export default function H5({ title, fontWeight = 'normal', theme = "title", underline = false, className = "" }) {
    return (
        <h5 className={`text-sm md:text-base font-${fontWeight} text-${theme} ${underline ? "underline" : ""} ${className}`}>
            {title}
        </h5>
    );
}
